{
	"language": {
		"select": "選擇語言",
		"sectionTitle": "語言",
		"changeSuccess": "語言已成功變更"
	},
	"assistant": {
		"composer": {
			"placeholder": "詢問 {{assistantName}}",
			"disclaimer": "{{assistantName}} 可能會出錯，重要資訊請自行查證。"
		},
		"greeting": {
			"initialMessage": "👋 你好，我是 **{{assistantName}}** 學習助理，我會協助你更充分地準備**{{context}}**！我們來仔細看看你在**{{topic}}**上作答的題目。",
			"starter": "你好，我是 **{{assistantName}}**。需要什麼協助嗎？"
		},
		"chips": {
			"askYourOwn": "提出你自己的問題",
			"askFollowUp": "提出後續問題"
		},
		"emptyState": {
			"title": "{{assistantName}} 是你的 AI 學習助理",
			"contextSubtitle": "有任何關於{{context}}的問題都可以問",
			"activateSubtitle": "作答後即可使用 {{assistantName}}"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "快速練習",
			"examInfo": {
				"subtitle": {
					"setExamDate": "設定考試日期",
					"examDateWithValue": "考試日期：<date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "還有進步空間",
				"itsAwesome": "非常棒"
			},
			"title": "你的表現愈來愈好了！",
			"body": "很高興看到你這麼認真學習！目前使用這個應用程式的體驗如何？願意留下評論分享你的想法嗎？",
			"cta": "稍後再說"
		},
		"actions": {
			"studyWeak": "加強弱項領域",
			"viewProgress": "查看學習進度",
			"seeRank": "查看排名",
			"seeRankings": "查看排行榜",
			"unlock": "解鎖進階內容",
			"unlockTooltip": "解鎖進階內容即可使用專屬功能與進階學習教材",
			"startCustomSession": "建立自訂練習",
			"startCustomSessionTooltip": "開始自訂練習，專注加強你想加強的領域",
			"takeDiagnostic": "進行診斷測驗",
			"takeDiagnosticTooltip": "透過診斷測驗了解目前程度，並據此調整學習計畫",
			"viewDiagnostic": "查看診斷結果",
			"viewDiagnosticTooltip": "查看診斷結果，了解你的強項與待加強之處",
			"viewPodcasts": "收聽 Podcast",
			"viewPodcastsTooltip": "收聽教學 Podcast，讓學習體驗更豐富",
			"upgradeToPremium": "升級進階版",
			"upgradeToPremiumTooltip": "升級至進階版即可使用所有內容與功能",
			"extendAccess": "延長使用期限",
			"extendAccessTooltip": "延長你使用進階內容與功能的期限",
			"setExamDate": "設定考試日期",
			"setExamDateTooltip": "設定考試日期即可追蹤進度並為考試做好準備"
		},
		"exam": {
			"daysAgo_one": "{{count}} 天前",
			"daysAgo_other": "{{count}} 天前",
			"untilExam_one": "距離考試還有 {{count}} 天",
			"untilExam_other": "距離考試還有 {{count}} 天",
			"isToday": "今天就是考試日！"
		},
		"stats": {
			"mastery": "精熟度",
			"completed_one": "已作答題目",
			"completed_other": "已作答題目",
			"completedValue": "{{count}}",
			"xpEarned": "獲得經驗值",
			"xpEarnedValue": "{{value}}",
			"accuracy": "正確率",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "你的 {{skill, lowercase}} 預估程度為 {{level, lowercase}}",
			"itemsAnsweredTooltip": "你目前已作答的題目總數",
			"responsesAnsweredTooltip": "你目前已送出的答案總數",
			"examDateTooltip": "你的考試日期為 {{date}}",
			"skillCta": {
				"diagnostic": "診斷",
				"practice": "練習"
			}
		},
		"menu": {
			"settings": "設定",
			"profile": "個人檔案"
		},
		"diagnostics": {
			"title": "診斷測驗",
			"free": "免費",
			"duration": "{{count}} {{item}} • {{minutes}} 分鐘",
			"completed": "已完成 {{count}} {{item}}",
			"start": "開始",
			"viewReport": "查看報告",
			"resume": "繼續作答"
		},
		"practiceTests": {
			"title": "模擬測驗",
			"sectionalTestsTitle": "分項測驗",
			"diagnosticAssessmentsTitle": "診斷測驗",
			"premiumChipTooltip": "{{examName}} 考試的完整長度進階模擬測驗",
			"freeChipTooltip": "{{examName}} 考試的{{label}}",
			"freeChipTooltipDefault": "{{examName}} 考試的免費診斷測驗",
			"completedDescription_one": "{{count}} 題 • {{date}}",
			"completedDescription_other": "{{count}} 題 • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} 題 • 剩餘 {{timeRemaining}}",
			"activeDescription_other": "{{attempted}}/{{count}} 題 • 剩餘 {{timeRemaining}}",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} 題 • 剩餘 {{timeRemaining}} • 開始日期：{{startedOn}} • 結束日期：{{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} 題 • 剩餘 {{timeRemaining}} • 開始日期：{{startedOn}} • 結束日期：{{endsOn}}",
			"notStartedDescription_one": "{{count}} 題 • {{duration}}",
			"notStartedDescription_other": "{{count}} 題 • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} 題 • {{duration}} • 結束日期：{{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} 題 • {{duration}} • 結束日期：{{endsOn}}",
			"viewResultsCta": "查看結果",
			"startCta": "開始",
			"chips": {
				"items_one": "{{count}} 題",
				"items_other": "{{count}} 題",
				"progress_one": "{{attempted}}/{{count}} 題",
				"progress_other": "{{attempted}}/{{count}} 題",
				"timeRemaining": "剩餘 {{time}}",
				"startedOn": "開始日期：{{date}}",
				"endsOn": "結束日期：{{date}}",
				"timeLeft": "剩餘 {{time}}"
			},
			"status": {
				"notStarted": {
					"label": "尚未開始",
					"section": "完整長度模擬測驗"
				},
				"inProgress": {
					"label": "進行中",
					"section": "進行中"
				},
				"completed": {
					"label": "已完成",
					"section": "已完成"
				},
				"legacyReports": {
					"label": "舊版報告",
					"section": "舊版報告"
				},
				"migratedReports": {
					"label": "已移轉報告",
					"section": "已移轉報告"
				}
			}
		},
		"skills": {
			"title": "能力項目",
			"unlockSubtitle": "解鎖進階版即可開始練習",
			"startCta": "練習",
			"freeItemsIncludedChip": "含免費題目",
			"freeItemsAnsweredSubtitle_one": "已完成 {{count, number}} 題免費題目中的 {{answered, number}} 題",
			"freeItemsAnsweredSubtitle_other": "已完成 {{count, number}} 題免費題目中的 {{answered, number}} 題",
			"progressCards": {
				"questionTypesTitle": "各題型表現",
				"questionTypesSubtitle": "你在各類 {{skill}} 題型的得分情形",
				"proficiencyTitle": "各程度表現",
				"proficiencySubtitle": "你在各 {{skill}} 程度的進度",
				"questionTypeCardSubtitle": "各程度進度",
				"bySkillTitle": "各能力表現",
				"bySkillSubtitle": "各項能力的整體進度",
				"needsImprovementTitle": "待加強項目",
				"needsImprovementSubtitle": "接下來應著重的主題",
				"skillPerformanceTitle": "{{skill}} 表現",
				"skillPerformanceSubtitle": "依題型與程度區分的進度",
				"skillLevelSubtitle": "你在此能力程度的進度",
				"skillsPerformanceTitle": "能力表現",
				"performanceByItemDifficulty": "各題目程度表現",
				"performanceByItemDifficultyCaption_one": "根據你已作答的 {{count}} 題，顯示各程度的正確率",
				"performanceByItemDifficultyCaption_other": "根據你已作答的 {{count}} 題，顯示各程度的正確率",
				"questionTypePartSubtitle": "{{skill}} · 第 {{part}} 部分",
				"activityGoalTitle": "活動與目標進度",
				"recentActivityTitle": "近期活動",
				"goalProgressTitle": "目標進度",
				"goalProgressSubtitle": "總分 · 最近 7 週",
				"goalProgressInsight": "你正穩定進步中。距離目標還差 14 分，預計約 3 週後可達成目標。",
				"goalProgressActualLabel": "你的分數",
				"goalProgressTargetLabel": "目標",
				"goalProgressTimeAxisLabel": "時間",
				"goalProgressScoreAxisLabel": "整體進度",
				"statusTitle": "你的狀態",
				"diagnosticsTitle": "診斷測驗",
				"diagnosticsReviewCta": "檢閱",
				"strengthsFocusTitle": "強項與待加強領域",
				"strengthsFocusSubtitle": "你最擅長的領域，以及需要多加練習的題型",
				"strengthsLabel": "強項",
				"focusAreasLabel": "待加強領域",
				"recommendedNextStepLabel": "建議的下一步",
				"recommendedNextStepCta": "開始",
				"practiceTestsViewMore": "查看全部 {{count}} 份測驗"
			},
			"proficiencySection": "依程度練習"
		},
		"recommendedTasks": {
			"sectionTitle": "為你推薦",
			"startSessionAction": "練習",
			"resumeAction": "繼續作答",
			"reviewResultsAction": "檢閱結果",
			"startTestAction": "開始測驗",
			"activeTestBody": "完成你進行中的測驗",
			"completedTestBody": "檢閱你的表現與作答內容",
			"diagnosticBody": "進行{{label}}，熟悉考試題型與形式",
			"diagnosticDefaultLabel": "免費診斷測驗",
			"practiceTestBody": "透過計時測驗評估你的應考準備程度。",
			"sectionalTestBody": "參加有針對性的測驗，練習你的{{skills}}技能。",
			"weakSkillTitle": "提升你的{{skill}}",
			"weakSkillBody": "{{questionType}}練習，著重你尚未掌握的部分。",
			"strongSkillTitle": "保持{{skill}}的手感",
			"strongSkillBody": "你在這方面表現不錯。快速練一組{{questionType}}來維持水準。",
			"mixedSkillTitle": "全面強化你的{{skill}}",
			"mixedSkillBody": "涵蓋 {{questionTypes}} 的混合練習，著重你答錯的部分。",
			"higherDifficultySkillTitle": "挑戰 {{proficiency}}",
			"higherDifficultySkillBody": "這個程度的{{questionType}}你已經掌握了。這些題目會再難一階。",
			"itemsChip_one": "{{count}} 題",
			"itemsChip_other": "{{count}} 題",
			"timeRemainingChip": "剩餘 {{minutes}} 分鐘",
			"timeRemainingChipCompact": "{{minutes}} 分鐘"
		},
		"itemTypes": {
			"answeredLabel_one": "已作答題目",
			"answeredLabel_other": "已作答題目",
			"answeredAll": "全部",
			"answeredPartial": "{{total}} 題中的 {{answered}} 題",
			"cardSubtitleComplete": "已作答所有題目",
			"cardSubtitlePartial": "已作答 {{total}} 題中的 {{attempted}} 題",
			"cardSubtitleResponses_one": "已作答 {{count}} 次",
			"cardSubtitleResponses_other": "已作答 {{count}} 次",
			"responsesLabel_one": "答案",
			"responsesLabel_other": "答案",
			"detail": {
				"skillLabel": "能力",
				"estimatedLevelLabel": "預估程度"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} 個{{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} 個{{label, lowercase}}",
			"responseCount_one": "已作答 {{count, number}} 次",
			"responseCount_other": "已作答 {{count, number}} 次"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "免費提供 {{count, number}} 道練習題",
			"freeContentBannerTitle_other": "免費提供 {{count, number}} 道練習題",
			"freeContentBannerBody": "隨時練習精選的 {{skills}} 題目。升級即可解鎖完整學習包。",
			"freeContentBannerCta": "開始免費練習"
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "看看你和其他人相比表現如何"
		},
		"home": {
			"title": "首頁"
		},
		"podcasts": {
			"description": "收聽專家主講的骨科 Podcast。"
		},
		"more": {
			"title": "更多設定"
		}
	},
	"emptyState": {
		"progress": {
			"title": "尚無學習進度",
			"subtitle": "開始學習後，你的進度就會顯示在這裡",
			"cta": "立即學習"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "發生錯誤",
			"body": "建立練習失敗，請再試一次"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "進階",
			"highIntermediate": "中級",
			"intermediate": "中級",
			"basic": "初級",
			"none": "未作答",
			"high": "已精熟",
			"medium": "就快成功了",
			"low": "需要加強"
		}
	},
	"leaderboard": {
		"you": "這是你",
		"periods": {
			"all_time": "全部時間",
			"month": "本月",
			"week": "本週"
		},
		"scope": {
			"global": "全球",
			"friends": "好友"
		},
		"friends": {
			"soon": "即將推出",
			"comingSoonTitle": "好友排行榜",
			"comingSoonBadge": "即將推出",
			"comingSoonDescription": "與好友比較學習進度，看看誰是班上第一名。"
		},
		"error": {
			"title": "連線錯誤",
			"description": "無法載入排行榜，請檢查你的網路連線後再試一次。",
			"tryAgain": "再試一次"
		},
		"empty": {
			"title": "尚無排名",
			"description": "隨著更多人開始學習，排名就會更新。搶先獲得經驗值，登上榜首吧！",
			"startLearning": "立即學習"
		},
		"topPerformers": "頂尖學習者",
		"yourPosition": "你的排名",
		"rankings": "排名",
		"rankingsRange": "排名 • 第 {{startRank}}–{{endRank}} 名",
		"unranked": {
			"title": "獲得經驗值即可加入排名！",
			"description": "開始一次練習，獲得你的第一筆分數並加入排行榜。",
			"cta": "開始第一次練習"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "你",
		"podium": {
			"first": "第 1 名",
			"second": "第 2 名",
			"third": "第 3 名"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>即可超越第 {{rank}} 名</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>就能擠進前三名</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "課程",
			"searchPlaceholder": "搜尋課程",
			"count_one": "{{count}} 堂課程",
			"count_other": "{{count}} 堂課程",
			"sortModalTitle": "課程排序",
			"filterModalTitle": "依主題篩選",
			"sort": {
				"popularity": "熱門程度",
				"popularityShort": "熱門",
				"topic": "主題",
				"difficulty": "難度",
				"recent": "最近更新",
				"recentShort": "更新",
				"completed": "已完成"
			},
			"chips": {
				"all": "全部",
				"recent": "最近更新",
				"completed": "已完成",
				"premium": "進階",
				"topics": "主題",
				"topicsCount_one": "{{count}} 個主題",
				"topicsCount_other": "{{count}} 個主題"
			},
			"chipTooltips": {
				"all": "顯示所有課程。",
				"recent": "顯示最近更新的課程。",
				"completed": "顯示已完成的課程。",
				"premium": "顯示進階課程。",
				"topics": "依主題篩選課程。"
			},
			"filterNames": {
				"premium": "進階",
				"completed": "已完成",
				"topics": "主題"
			},
			"empty": {
				"searchTitle_one": "{{count}} 堂課程因搜尋而隱藏",
				"searchTitle_other": "{{count}} 堂課程因搜尋而隱藏",
				"searchSubtitle": "試試其他關鍵字或清除搜尋",
				"searchCta": "清除搜尋",
				"filtersTitle_one": "{{count}} 堂課程因篩選而隱藏",
				"filtersTitle_other": "{{count}} 堂課程因篩選而隱藏",
				"filtersSubtitle_one": "移除{{filters}}篩選以查看更多",
				"filtersSubtitle_other": "移除{{filters}}篩選以查看更多",
				"filtersCta": "清除所有篩選",
				"noneTitle": "找不到課程",
				"noneSubtitle": "請嘗試移除篩選或重新搜尋",
				"noneCta": "全部重設"
			}
		},
		"home": {
			"settings": {
				"a11yLabel": "開啟設定"
			},
			"continueLearning": {
				"title": "繼續學習"
			},
			"suggested": {
				"title": "為你推薦"
			},
			"completed": {
				"title": "已完成"
			},
			"all": {
				"title": "全部課程"
			},
			"emptyState": {
				"title": "尚無課程",
				"subtitle": "敬請期待新課程。"
			},
			"card": {
				"resumeCta": "繼續",
				"progress": "已完成 {{value}}%",
				"timeLeft_one": "剩餘 {{count}} 分鐘",
				"timeLeft_other": "剩餘 {{count}} 分鐘",
				"duration_one": "{{count}} 分鐘",
				"duration_other": "{{count}} 分鐘"
			}
		},
		"overview": {
			"header": {
				"title": "總覽"
			},
			"startCta": "開始學習",
			"objectives": {
				"title": "學習目標"
			}
		},
		"detail": {
			"takeQuizCta": "開始測驗",
			"progress": {
				"label": "單元進度"
			},
			"activities": {
				"title": "活動",
				"completedCount": "已完成 {{completed}}/{{total}}"
			},
			"artifact": {
				"completed": "已完成",
				"locked": "已鎖定"
			}
		},
		"stats": {
			"insights": {
				"title": "進度洞察"
			},
			"overallProgress": {
				"title": "整體進度",
				"completedCount_one": "已完成 {{completed}}/{{count}} 項",
				"completedCount_other": "已完成 {{completed}}/{{count}} 項"
			},
			"milestones": {
				"title": "單元里程碑"
			}
		},
		"studyGuide": {
			"sectionBadge": {
				"label": "第 {{number}} 節，共 {{total}} 節"
			},
			"upNext": {
				"title": "接下來"
			}
		}
	},
	"sessionConfig": {
		"title": "自訂學習練習",
		"diagnostic": "診斷測驗",
		"skill": "能力項目",
		"Proficiency": "程度",
		"Question Type": "題型",
		"mastery": "精熟度",
		"sessionLength": "學習時長",
		"itemsChip_one": "{{count}} 題",
		"itemsChip_other": "{{count}} 題",
		"durationEstimate": "{{minutes}} 分鐘",
		"durationRange": "{{min}}–{{max}} 分鐘",
		"noItemsTooltip": "沒有符合目前篩選條件的題目",
		"setCount": "{{count}} {{type}}",
		"dismiss": "確定",
		"status": {
			"notAnswered": "未作答",
			"needsWork": "需要加強"
		},
		"itemCount": "你將完成 {{topics}} 中的 {{count}} 道題目",
		"start": "開始練習",
		"configuringSession": "正在設定練習",
		"fetchingContent": "正在取得內容",
		"preparingMaterials": "正在準備教材",
		"almostThere": "就快好了",
		"startingSession": "正在開始練習",
		"playIcon": "play-outline",
		"infoText": "你將完成 **{{numItems}}** {{itemCount}}，預計花費約 **{{timeString}}**。",
		"customSummary": {
			"message": "從 {{topics}} 中學習 $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})。",
			"messageWithMastery": "從 {{topics}} 中學習 $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})，並著重於{{masteryLevels}}$t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}})。",
			"messageAllMasteryLevels": "從 {{topics}} 中學習 $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})，涵蓋所有精熟度等級。",
			"itemCount_one": "{{count}} 道題目",
			"itemCount_other": "{{count}} 道題目",
			"masteryLevelCount_one": "精熟度等級",
			"masteryLevelCount_other": "精熟度等級",
			"allTopics": "全部 {{count}} 個主題",
			"more": "另外 {{count}} 個",
			"quotedMasteryLevel": "「{{masteryLevel}}」"
		},
		"quickStudy": {
			"title": "快速練習",
			"recommended": "推薦",
			"custom": "自訂",
			"selectHelper": "點選一項練習來選取，準備好後即可開始。",
			"emptyRecommended": "目前沒有推薦的練習。",
			"summary": "從{{skill}}中學習 {{count}} 道題目，預計 {{minutes}} 分鐘。",
			"summary_questionType": "從{{skill}}的 {{questionType}} 中學習 {{count}} 道題目，預計 {{minutes}} 分鐘。",
			"duration": "{{minutes}} 分鐘",
			"levelSessions": {
				"rapidRecall": "快速回想",
				"purposefulPractice": "目標導向練習",
				"focusFlow": "專注加強",
				"itemsLabel": "{{level}}題目",
				"itemsLabelGeneric": "題目",
				"summaries": {
					"rapidRecall": "快速瀏覽 {{count}} 道尚未作答的{{level}}題目，穩定擴大你的學習範圍。預計 {{minutes}} 分鐘。",
					"purposefulPractice": "從最需要加強的內容開始，完成一組均衡的 {{count}} 道{{level}}題目。預計 {{minutes}} 分鐘。",
					"focusFlow": "透過 {{count}} 道你精熟度偏低或中等的{{level}}題目，加強你的弱項。預計 {{minutes}} 分鐘。"
				},
				"summariesGeneric": {
					"rapidRecall": "快速瀏覽 {{count}} 道尚未作答的題目，穩定擴大你的學習範圍。預計 {{minutes}} 分鐘。",
					"purposefulPractice": "從最需要加強的內容開始，完成一組均衡的 {{count}} 道題目。預計 {{minutes}} 分鐘。",
					"focusFlow": "透過 {{count}} 道你精熟度偏低或中等的題目，加強你的弱項。預計 {{minutes}} 分鐘。"
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium",
			"durationSelector": {
				"title": "時長"
			}
		}
	},
	"skillDetail": {
		"diagnosticInsight": "為了讓你的學習體驗更個人化，請先做一次診斷測驗。診斷結果將用於建立你的學習計畫。"
	},
	"premium": {
		"chip": "進階版",
		"upgrade": "升級進階版",
		"unlockTitle": "解鎖完整的 {{productName}} 體驗",
		"unlockDescription": "解鎖依你剩餘準備時間量身打造的個人化練習。",
		"readyTitle": "為 {{date}} 的考試做好萬全準備",
		"tip": "進階版提供專屬於你的學習重點，指出接下來該練習什麼，並隨著你的進步調整學習計畫。"
	},
	"purchase": {
		"success": {
			"headerTitle": "感謝你的購買！",
			"accessGranted": "你的{{name}}使用權已成功開通",
			"studyPack": "學習包",
			"practiceTest": "模擬測驗",
			"combo": "組合方案",
			"documentTitle": "購買",
			"summary_one": "恭喜！下方的**產品**已在你的帳號中解鎖。按下{{action}}後，應用程式的內容將切換為以下考試：**{{examName}}**。若你想準備其他考試或購買其他產品，隨時可在帳號設定中變更。",
			"summary_other": "恭喜！下方的**{{count}} 項產品**已在你的帳號中解鎖。按下{{action}}後，應用程式的內容將切換為以下考試：**{{examName}}**。若你想準備其他考試或購買其他產品，隨時可在帳號設定中變更。",
			"unlockedDuration": "恭喜！你已解鎖 **{{name}}** 的 **{{duration}}** 使用權，將於 **{{expiry}}** 到期。",
			"storeNote": "注意：學習包僅能透過我們的行動應用程式使用。請下載適合你裝置的應用程式。",
			"actions": {
				"goToHome": "前往首頁",
				"startDiagnostic": "開始{{label}}",
				"takeDiagnostic": "進行{{label}}",
				"takeFreeDiagnostic": "進行免費診斷測驗",
				"diagnosticLabel": "診斷測驗"
			}
		},
		"checkout": {
			"headerTitle": "完成購買"
		},
		"paywall": {
			"studyPackDialogTitle": "升級你的學習計畫",
			"defaultDialogTitle": "升級你的學習計畫",
			"practiceTestDialogTitle": "解鎖模擬測驗",
			"restorePurchaseDialogTitle": "已經購買過了嗎？",
			"restorePurchaseDialogSubheadingWeb": "如果不是，請嘗試以下做法：",
			"restorePurchaseDialogBody": "如果你已購買此產品但仍顯示鎖定，請嘗試以下做法：\n\n1. 確認你已登入正確的帳號\n2. 確認你已選取正確的產品\n3. 確認你的訂閱尚未到期\n4. 確認你已啟用訂閱（請一併檢查垃圾郵件匣）\n5. 如果你有存取碼，請使用[存取碼]({{baseUrl}}/redeem)\n\n若以上皆不符合，請**點選這裡**",
			"restorePurchaseDialogBodyWeb": "1. 確認你已登入正確的電子郵件帳號\n2. 確認你已**[選取正確的考試](/account/settings)**\n3. 確認你的訂閱尚未到期\n\n若以上皆不符合，請**聯絡客服**",
			"accesDuration": {
				"yearPlan": "**{{duration}}**方案提供更長的使用期限，讓你能依自己的步調充分準備考試。",
				"moreTime": "如果你覺得需要更多時間準備，可以考慮**{{duration}}**方案。",
				"otherPlan": "**{{duration}}**方案的使用期限至 **{{expiryText}}**，足以讓你完成準備。{{moreTime}}"
			},
			"actions": {
				"upgrade": "升級",
				"unlock": "以 {{price}} 解鎖",
				"subscribe": "以 {{price}} 訂閱",
				"extendAccess": "延長使用期限",
				"accessHere": "由此進入",
				"redeemAccessCode": "有存取碼嗎？",
				"restorePurchase": "已經購買過了嗎？",
				"restorePurchaseWeb": "已經購買過或有存取碼嗎？"
			},
			"subscriptionSummary": {
				"yearly": "年度訂閱 • 自動續訂 • 可隨時取消",
				"monthly": "月訂閱 • 自動續訂 • 可隨時取消",
				"weekly": "週訂閱 • 自動續訂 • 可隨時取消",
				"generic": "自動續訂訂閱 • 可隨時取消"
			},
			"planDuration": {
				"day_one": "{{count}} 天",
				"day_other": "{{count}} 天",
				"week_one": "{{count}} 週",
				"week_other": "{{count}} 週",
				"month_one": "{{count}} 個月",
				"month_other": "{{count}} 個月",
				"year_one": "{{count}} 年",
				"year_other": "{{count}} 年"
			},
			"recommendedPlan": {
				"plan": "我們建議選擇「**{{duration}}**」方案，為你 **{{date}}** 的考試做最好的準備",
				"subscription": {
					"yearly": "我們建議選擇**年度訂閱**，持續為你 **{{date}}** 的考試做準備",
					"monthly": "我們建議選擇**月訂閱**，持續為你 **{{date}}** 的考試做準備",
					"weekly": "我們建議選擇**週訂閱**，持續為你 **{{date}}** 的考試做準備",
					"generic": "我們建議選擇**訂閱**方案，持續為你 **{{date}}** 的考試做準備"
				}
			},
			"disclaimer": "確認購買後，你將在所選期限內取得此產品的完整內容使用權。期限屆滿後，你將無法再存取受限內容。若因故需要延長使用期限（例如你更改了考試日期），可透過額外的應用程式內購買加購時間。詳情請參閱我們的[服務條款與隱私權政策](https://memorang.com/legal)。"
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "根據你在 {{count}} 個{{type}}中已作答的 {{numItems}} {{item}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "這顯示你在 {{count}} 個{{type}}中的進度，依據你目前已作答的 {{itemCount}} {{item}} 計算。"
		},
		"needsImprovement": {
			"title": "待加強項目",
			"subtitle": "建議你加強的{{type}}",
			"cta": "立即學習"
		},
		"mastery": {
			"high": "已精熟",
			"medium": "就快成功了",
			"low": "需要加強",
			"count": "已作答 {{count}} {{item}}",
			"zeroTooltip": "在已作答的 {{total}} 道題目中尚無{{label}}題目",
			"highTooltip": "在已作答的 {{total}} {{item}} 中，你已精熟 {{count}} 題",
			"mediumTooltip": "在已作答的 {{total}} {{item}} 中，你有 {{count}} 題正在進步",
			"lowTooltip": "在已作答的 {{total}} {{item}} 中，有 {{count}} 題需要多加練習"
		},
		"stats": {
			"completion": "完成度",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "你已完成 {{total}} {{item}} 中的 {{completed}} 題"
		},
		"exams": {
			"title": "模擬測驗",
			"subtitle_one": "根據已完成的 {{count}} 份評量",
			"subtitle_other": "根據已完成的 {{count}} 份評量"
		},
		"summary": {
			"title": "學習總覽",
			"subtitle": "根據已作答的 {{count}} {{item}}",
			"tooltip": "此總覽顯示你在全部 {{count}} {{item}} 的精熟度與完成進度。你的表現是透過練習、評量與學習活動計算而得。",
			"mastery": "精熟度",
			"quickStats": "快速統計"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}}程度",
			"proficiencyCardTooltip": "你目前的{{skill, lowercase}}表現屬於 {{level, lowercase}} 程度",
			"itemTypesCardSubtitle_one": "{{count}} 種題型",
			"itemTypesCardSubtitle_other": "{{count}} 種題型",
			"itemTypesCardTitle": "{{skill}}題目",
			"itemTypeLevelTooltip": "在「{{itemType}}」題型上，你目前的{{skill, lowercase}}表現屬於 {{level, lowercase}} 程度",
			"itemTypesFallbackTitle": "題目類型",
			"itemTypesEmptyTitle": "無法取得題目類型",
			"itemTypesEmptySubtitle": "我們找不到這項能力的題目類型。請返回「學習進度」後再試一次。",
			"itemTypesEmptyCta": "返回學習進度",
			"notAnswered": "未作答",
			"answeredSubtitle_one": "根據已作答的 {{count}} 題",
			"answeredSubtitle_other": "根據已作答的 {{count}} 題",
			"responsesSubtitle_one": "根據已作答的 {{count}} 筆",
			"responsesSubtitle_other": "根據已作答的 {{count}} 筆",
			"testsTakenSubtitle_one": "根據已完成的 {{count}} 份測驗",
			"testsTakenSubtitle_other": "根據已完成的 {{count}} 份測驗",
			"startFirstTest": {
				"title": "開始吧",
				"itemsSubtitle_one": "{{count}} 題",
				"itemsSubtitle_other": "{{count}} 題",
				"guidance": {
					"diagnostic": "先做一次診斷測驗，了解你的強項並據此調整學習計畫。",
					"sectional": "分項測驗只針對考試的一個部分，因此能以較短的作答時間取得成績。",
					"fullMock": "完整模擬測驗完全比照真實考試的流程，能提供最完整的成績。"
				}
			},
			"noScoresTitle": "尚無{{skill, lowercase}}成績",
			"noScoresSubtitle": "完成第一次測驗，即可查看你的預估成績和任務細分。",
			"noScoresCta": "開始",
			"noScoresCardSubtitle": "根據你參加的測驗",
			"personalBestLabel": "你的最佳成績",
			"latestLabel": "你的最新成績",
			"examCountdown_one": "距離考試還有 {{count}} 天",
			"examCountdown_other": "距離考試還有 {{count}} 天",
			"greeting": {
				"none": "{{firstName}}，我們開始吧！🚀",
				"low": "{{firstName}}，開始得不錯，繼續加油！💪",
				"medium": "{{firstName}}，保持下去！💪",
				"high": "{{firstName}}，你就快成功了！🎯"
			},
			"greetingNoName": {
				"none": "我們開始吧！🚀",
				"low": "開始得不錯，繼續加油！💪",
				"medium": "保持下去！💪",
				"high": "你就快成功了！🎯"
			},
			"stats": {
				"untilExam": "考試日期",
				"itemsAnswered": "已作答題目",
				"responsesAnswered": "答案"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "通行碼不正確",
		"incorrectPassword": "密碼不正確，請再試一次。",
		"passwordPlaceholder": "請輸入密碼",
		"emailPlaceholder": "例如：dave@gmail.com",
		"verify": {
			"openEmail": "開啟電子郵件以繼續",
			"signInCta": "正在驗證你的帳號...",
			"signUpCta": "正在建立你的帳號...",
			"contactSupport": "沒看到電子郵件嗎？請檢查垃圾郵件匣，或",
			"contactSupportLink": "與我們聯絡",
			"resendMagicLink": "重新傳送快速登入連結",
			"resendMagicLinkIn": "{{time}} 後可重新傳送快速登入連結",
			"signInBody": "就快完成了！我們正在驗證你的資料，讓你安全登入 {{appName}} 應用程式。",
			"signUpBody": "就快完成了！我們正在驗證你的資料，為你建立新的 {{appName}} 應用程式帳號。",
			"magicLinkEmail": "我們已將快速登入連結寄至 **{{email}}**\n請點選電子郵件中的連結以安全登入。",
			"magicLinkEmailExpiry": "此連結將於 10 分鐘後失效",
			"confirmEmail": "確認你的電子郵件",
			"redirectingToApp": "正在前往 {{appName}} 應用程式...",
			"appNotOpen": "應用程式沒有開啟嗎？請點選下方按鈕開啟對應的應用程式",
			"openApp": "開啟 {{appName}} 應用程式",
			"installAppPrompt": "如果沒有任何反應，請確認你的裝置已安裝 {{appName}} 應用程式",
			"verifyAccountTitle": "驗證你的帳號",
			"emailResent": "快速登入連結已寄至 {{email}}\n請檢查你的收件匣，也別忘了看看垃圾郵件匣。",
			"verificationLinkExpired": "驗證連結已失效",
			"verificationLinkExpiredBody": "驗證連結會在 10 分鐘後失效，且只能使用一次。\n你可以重新登入以取得新的連結",
			"accountSetupTimeoutTitle": "無法完成登入",
			"accountSetupTimeoutBody": "你的帳號設定所需時間比預期長。請嘗試重新登入，若問題持續發生請聯絡客服。",
			"loginAgain": "重新登入",
			"contactSupportExpiredLink": "如果問題持續發生，請告訴我們",
			"successTitle": "你已在其他分頁登入",
			"successBody": "請關閉此分頁，或從這裡繼續",
			"successCtaLabel": "在這裡繼續",
			"needHelpLabel": "需要協助嗎？",
			"contactSupportButton": "聯絡客服"
		},
		"contactSupportDialog": {
			"title": "登入時遇到問題嗎？",
			"body": "如果你在登入時遇到問題，請聯絡我們的客服，或再試一次",
			"cta": "寄信給我們"
		},
		"emailInstruction": {
			"default": "如果沒有收到電子郵件，請檢查垃圾郵件、廣告郵件與最近刪除的資料夾",
			"edu": "如果沒有收到電子郵件，請檢查垃圾郵件、廣告郵件與最近刪除的資料夾，或聯絡你的 IT 管理員"
		},
		"createSessionLoader": {
			"configuringSession": "正在設定練習",
			"analyzingMastery": "正在分析精熟度",
			"loadingContent": "正在載入內容"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "我們該如何稱呼你？",
				"description": "你的使用者名稱會顯示在公開排行榜上，姓名則不會公開。",
				"usernameLabel": "使用者名稱",
				"firstNameLabel": "名字",
				"lastNameLabel": "姓氏",
				"avatarLabel": "頭像",
				"avatarTooltip": "頭像會依你的使用者名稱自動產生。",
				"profileSaveFailed": "無法儲存你的個人檔案，請再試一次。"
			},
			"testDate": {
				"cta": "繼續"
			},
			"examDate": {
				"daysAway": "這樣我們還有 {{value}} 天。我們會立即優先加強你最弱的部分。"
			},
			"skills": {
				"chooseAll": "請選取所有符合的項目"
			},
			"plan": {
				"recommended": "推薦"
			},
			"toeicLevelOverview": {
				"title": "每個人都從某個起點開始。",
				"description": "練習能幫助你在一個程度打好基礎，再自然而然地邁向下一個階段。",
				"illustrationLabel": "從初級（A1–A2）到中級（B1–B2），再到精通（C1）的進程。",
				"levels": {
					"basic": {
						"name": "初級",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "中級",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "精通",
						"band": "C1"
					}
				},
				"progression": {
					"title": "你的進步歷程",
					"practiceSessions": "完成推薦的練習",
					"buildMastery": "在目前程度打好基礎",
					"growToward": "持續朝精通程度邁進"
				},
				"levelDetails": {
					"title": "各程度代表的意義",
					"scoreRange": "{{band}} · 分數 {{min}}–{{max}}",
					"basic": {
						"name": "初級使用者",
						"summary": "簡單的職場英文",
						"examples": {
							"forms": "表單與公告",
							"instructions": "操作說明",
							"announcements": "簡短的廣播通知"
						}
					},
					"intermediate": {
						"name": "中級使用者",
						"summary": "日常職場溝通",
						"examples": {
							"emails": "電子郵件與對話",
							"customers": "客戶互動",
							"followUps": "會議後續追蹤"
						}
					},
					"proficient": {
						"name": "精通使用者",
						"summary": "專業與進階英文",
						"examples": {
							"reports": "複雜的報告與簡報",
							"negotiations": "細膩的協商溝通",
							"highStakes": "高風險的專業情境"
						}
					}
				},
				"disclaimer": "TOEIC Link 分數是對應 CEFR 的參考指引，並非絕對的通過門檻。閱讀與聽力的進步各自獨立，你在兩項能力上可能達到不同程度。"
			},
			"review": {
				"diagnosticChoice": {
					"title": "診斷測驗：{{title}}",
					"body": "{{count}} 道題目，協助你找出該加強的重點",
					"duration": "{{minutes}} 分鐘"
				},
				"homeChoice": {
					"title": "我想自己探索",
					"body": "還沒準備好開始，我想先看看這個應用程式"
				}
			}
		},
		"common": {
			"changeLater": "你之後可以隨時變更"
		},
		"actions": {
			"previous": "上一步",
			"finish": "完成",
			"start": "開始",
			"continue": "繼續",
			"stepIndicator": "第 {{step}} 步，共 {{total}} 步"
		}
	},
	"more": {
		"profile": {
			"title": "關於你"
		},
		"exam": {
			"title": "你的考試"
		},
		"subscriptions": {
			"title": "產品",
			"redeem": {
				"title": "兌換購買項目"
			},
			"extend": {
				"cta": "延長"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "設定你的目標考試日期",
			"description": "此日期僅用於在應用程式中安排你的學習進度，不會影響你的正式考試報名。",
			"dismissCta": "暫時不要",
			"confirmCta": "設定考試日期"
		}
	},
	"account": {
		"title": "帳號設定",
		"currentExam": "目前的考試",
		"subscriptions": "產品",
		"examDate": "考試日期",
		"examDateUpdated": "考試日期已設為 {{date}}",
		"selectDate": "選擇日期",
		"appearance": "外觀",
		"features": "功能",
		"audioPlaybackTest": "顯示音訊播放測試對話方塊",
		"theme": "主題",
		"selectTheme": "選擇主題",
		"themeOptions": {
			"system": "跟隨系統",
			"light": "淺色",
			"dark": "深色"
		},
		"accountInfo": "帳號",
		"username": "使用者名稱",
		"name": "姓名",
		"nameNotSet": "尚未設定",
		"save": "儲存",
		"editUsername": {
			"title": "編輯使用者名稱"
		},
		"editName": {
			"title": "編輯姓名"
		},
		"email": "電子郵件",
		"dev": "開發",
		"sandbox": "沙箱",
		"redoOnboarding": "重新進行新手引導",
		"about": "關於",
		"termsOfService": "服務條款",
		"privacyPolicy": "隱私權政策",
		"aiToolsTos": "AI 工具使用條款",
		"support": "支援",
		"supportEmailBody": "我來信是因為需要協助處理 [  ]\n\n\n\n以下資訊有助於更快解決問題： \n\n此帳號使用的使用者名稱（登入應用程式後可在設定中找到）：\n{{username}}\n\n訂單使用的電子郵件（登入應用程式後可在設定中找到）：\n{{email}}\n\n訂單編號（通常可在購買後收到的收據郵件中找到）：\n\n實際購買時是否可能使用了不同的姓名或電子郵件？如果是，請提供：\n\n姓名：\n\n電子郵件：",
		"contactSupport": "聯絡客服",
		"signOut": "登出",
		"signOutConfirmation": "確定要登出嗎？",
		"deleteAccount": "刪除帳號",
		"platform": "平台",
		"partnerships": "合作夥伴",
		"validUntil": "於 {{date}} 到期",
		"extendValidity": "延長使用期限",
		"redeemPurchase": "兌換購買",
		"redeemPurchaseNoneFound": "沒有可兌換的購買",
		"redeemPurchaseCheckFailed": "無法檢查購買記錄，請重試。",
		"purchases": "購買",
		"frequentlyAskedQuestions": "常見問題",
		"deleteFeedbackForm": {
			"placeholder": "意見回饋"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "需要更多資料",
		"proficiencyLevelPendingTooltip": "多作答一些{{label}}題目，我們才能估算你的程度",
		"on": "於",
		"gotIt": "我知道了",
		"goBack": "返回",
		"topic": "主題",
		"itemCount_one": "{{count, number}} 道題目",
		"itemCount_other": "{{count, number}} 道題目",
		"examCount_one": "{{count}} 場考試",
		"examCount_other": "{{count}} 場考試",
		"questionCount_one": "{{count}} 個問題",
		"questionCount_other": "{{count}} 個問題",
		"item_one": "題目",
		"item_other": "題目",
		"and": "和",
		"this": "這個",
		"of": "／",
		"knowMore": "了解更多",
		"proficiency": "程度",
		"didNotAnswer": "你尚未作答的題目",
		"notAnswered": "未作答",
		"attempted": "已作答",
		"attempt": "作答",
		"activity": "活動",
		"performance": "表現",
		"estimatedProficiency": "預估程度",
		"details": "詳細資料",
		"keepPracticing": "繼續加油！",
		"leaveFeedback": "提供意見回饋",
		"copiedToClipboard": "已複製到剪貼簿",
		"eg": "例如",
		"set": "組",
		"hint": "提示",
		"itemType": "題目類型",
		"minute": "分鐘",
		"minutes": "{{count}} 分鐘",
		"hour": "小時",
		"hours": "{{count}} 小時",
		"continue": "繼續",
		"unlock": "解鎖",
		"cancel": "取消",
		"view": "查看",
		"switch": "切換",
		"update": "更新",
		"ok": "確定",
		"yes": "是",
		"free": "免費",
		"answered": "已作答",
		"correct": "正確",
		"incorrect": "錯誤",
		"marked": "已標記",
		"unmarked": "未標記",
		"skipped": "已略過",
		"skill_one": "能力項目",
		"skill_other": "能力項目",
		"word_one": "字",
		"word_other": "字",
		"submitResponse": "送出答案",
		"viewDetails": "查看詳細資料",
		"sec_one": "秒",
		"sec_other": "秒",
		"point_one": "分",
		"point_other": "分",
		"week": "週",
		"month": "月",
		"year": "年",
		"day": "日",
		"selectTestDate": "選擇考試日期",
		"points": "分數",
		"viewAll": "查看全部",
		"timeline": "時間軸",
		"save": "儲存",
		"filters": {
			"selectAll": "全選",
			"deselectAll": "取消全選",
			"selectedCount": "已選取 {{count}} 項",
			"expandSection": "展開{{section}}",
			"collapseSection": "收合{{section}}"
		},
		"showMore": "顯示更多",
		"showLess": "顯示較少",
		"expandA11yLabel": "展開說明",
		"collapseA11yLabel": "收合說明",
		"done": "完成",
		"clearAll": "清除全部",
		"clear": "清除",
		"datePicker": {
			"title": "選擇日期",
			"enterDateLabel": "輸入日期",
			"enterDateRangeLabel": "輸入日期範圍",
			"dateLabel": "日期",
			"startDateLabel": "開始日期",
			"endDateLabel": "結束日期",
			"dateRequiredError": "請輸入日期",
			"invalidDateFormatError": "日期格式無效，請使用 MM/DD/YYYY",
			"startAfterEndError": "開始日期不能晚於結束日期",
			"endBeforeStartError": "結束日期不能早於開始日期",
			"minDateError": "日期必須為 {{date}} 或之後",
			"maxDateError": "日期必須為 {{date}} 或之前",
			"dateRangeError": "日期必須在 {{startDate}} 至 {{endDate}} 之間",
			"setDateCta": "設定日期",
			"nextCta": "下一步",
			"setTimeCta": "設定時間"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}}的學習者選擇了此答案。",
		"choiceCorrectA11yLabel": "正確答案",
		"choiceIncorrectA11yLabel": "錯誤答案",
		"choiceNotSelectedA11yLabel": "未選擇",
		"moreItemsAlertDialog": {
			"title": "額外題目",
			"cta": "我知道了"
		},
		"results": {
			"followUps": {
				"title": "延伸提問"
			},
			"summary": {
				"sessionAnalysis": "練習分析",
				"itemCount_one": "{{count}} 道題目",
				"itemCount_other": "{{count}} 道題目",
				"skilledItemCount_one": "{{count}} 道{{skills}}題目",
				"skilledItemCount_other": "{{count}} 道{{skills}}題目",
				"levelPhrase_one": "{{levels}}程度的",
				"levelPhrase_other": "{{levels}}程度的",
				"message": "<bold>做得好！</bold>你在 {{timeTaken}} 內完成了{{itemPhrase}}。",
				"messageWithLevels": "<bold>做得好！</bold>你在 {{timeTaken}} 內完成了$t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}){{itemPhrase}}。",
				"proficiencyEstimateReady": "你的{{skill}}預估程度為 <bold>{{currentLevel}}</bold>，現在可以朝 <bold>{{nextLevel}}</bold> 邁進了。",
				"proficiencyEstimateKeepPracticing": "你的{{skill}}預估程度為 <bold>{{currentLevel}}</bold>。再多練習一些，然後再挑戰 <bold>{{nextLevel}}</bold>。",
				"proficiencyEstimateHighest": "你的{{skill}}預估程度為 <bold>{{currentLevel}}</bold>，表現非常出色！",
				"mixedLevel": "混合",
				"overallScore": "總分",
				"stats": {
					"itemsAttempted_one": "已作答題目",
					"itemsAttempted_other": "已作答題目",
					"pointsEarned_one": "獲得分數",
					"pointsEarned_other": "獲得分數",
					"answeredCorrectly": "答對題目",
					"timeTaken": "花費時間",
					"target": "目標",
					"ofTotal": "／{{total}}",
					"ofPointsTotal": "／{{total}}",
					"skill": "能力項目",
					"skills": "能力項目",
					"questionType": "題型",
					"questionTypes": "題型",
					"proficiencyLevel": "程度等級",
					"proficiencyLevels": "程度等級"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "音訊將在 {{seconds}} 秒後開始播放",
			"audioStartsInPlayOnce": "音訊將在 {{seconds}} 秒後開始播放，僅播放一次",
			"videoStartsIn": "影片將在 {{seconds}} 秒後開始播放",
			"videoStartsInPlayOnce": "影片將在 {{seconds}} 秒後開始播放，僅播放一次",
			"recordingIn": "將在 {{seconds}} 秒後開始錄音"
		},
		"timeOverrunBanner": {
			"message": "時間到。在正式考試中，此時間之後的作答將不予計分。你仍可以繼續練習。"
		},
		"attributes": {
			"stimulus": "題幹素材"
		},
		"stimulusTypes": {
			"reading": "閱讀",
			"listening": "聽力",
			"speaking": "口說",
			"writing": "寫作",
			"image": "圖片"
		},
		"masteryLevels": {
			"belowBasic": "初級以下",
			"basic": "初級",
			"belowLowIntermediate": "中低級以下",
			"lowIntermediate": "中低級",
			"highIntermediate": "中高級",
			"advanced": "進階",
			"proficiencySubtitle": "在 {{trademark}} 中，這相當於 **{{minScore}}-{{maxScore}}/30** 分",
			"infoSectionLabel": "{{skill}}測驗說明",
			"infoSectionText": {
				"Reading": "{{trademark}} 閱讀測驗評估你閱讀並理解學術環境書面資料的能力，包含兩篇約 700 字的文章，每篇文章有 10 道題目。完成閱讀測驗約需 35 分鐘。",
				"Listening": "{{trademark}} 聽力測驗用於評量你理解英語對話與講課內容的能力，內容涵蓋基本理解、掌握說話者的態度與確信程度，以及連結資訊等能力。完成聽力測驗約需 36 分鐘。",
				"Speaking": "{{trademark}} 口說測驗評量你在學術情境中有效運用英語口說的能力。四道題目／任務模擬你在課堂內外可能遇到的真實情境。完成口說測驗約需 16 分鐘。",
				"Writing": "{{trademark}} 寫作測驗評量你在學術情境中以英語寫作，並清楚且條理分明地表達想法的能力。你將使用電腦鍵盤輸入作答內容，完成寫作測驗約需 29 分鐘。"
			}
		},
		"itemTypes": {
			"MCSS": "單選題",
			"MCSSH": "單選標記題",
			"MCMS": "複選題",
			"MCMSH": "複選標記題",
			"INSERT_TEXT": "插入句子",
			"MATCH_MS": "複選配對題",
			"MCSSM": "單選配對題",
			"MCMSM": "複選配對題",
			"MCGS": "選填空格題",
			"MCOS": "選項排序題",
			"LISTENING_REPLAY": "聽力重播",
			"AUDIO_INPUT": "語音作答",
			"ACADEMIC_DISCUSSION_RESPONSE": "學術討論作答",
			"INTEGRATED_WRITING_RESPONSE": "整合寫作作答"
		},
		"passageStem": {
			"itemOfTotal": "第 {{current}} 題，共 {{total}} 題",
			"questionOfTotal": "第 {{current}} 題，共 {{total}} 題",
			"stimulusCorrespondsToNextItems": "以下素材對應接下來的 {{total}} 道題目",
			"passage": "文章",
			"lecture": "講課",
			"professorsQuestion": "教授的提問",
			"listen": "聆聽",
			"openPassage": "開啟文章",
			"backToItem": "返回題目",
			"notYetInserted": "尚未插入",
			"insertedAtPosition": "已插入至第 {{position}} 個位置"
		},
		"hint": {
			"show": "顯示提示"
		},
		"navigation": {
			"next": "下一題",
			"exit": "離開",
			"saveAndExit": "儲存並離開",
			"previous": "上一題",
			"skip": "略過",
			"finish": "完成",
			"help": "說明",
			"about": "答題技巧",
			"questionsButtonLabel": "題目導覽",
			"questionsButtonTooltip": "跳至任一題目，或檢閱已標記的題目",
			"questionsButtonActiveFiltersA11y": "已套用的篩選條件：{{count}}",
			"recordingInProgressTooltip": "錄音進行中，無法離開此題",
			"questionNotReachedTooltip": "你尚未進行到這一題"
		},
		"questionTips": {
			"hideFutureLabel": "不自動顯示技巧"
		},
		"toolbar": {
			"calculatorTooltip": "開啟計算機",
			"highlightTooltip": "選取文字以標示重要資訊，方便日後查看",
			"markTooltip": "標記此題，以便在送出前回頭檢視",
			"unmarkTooltip": "點選以取消標記此題"
		},
		"summary": {
			"viewFullInsights": "查看完整洞察",
			"targetTooltip": "此次練習的表現目標。"
		},
		"stats": {
			"skill": "能力項目",
			"answered": "已作答",
			"speed": "速度",
			"duration": "長度",
			"duration_tooltip": "你錄製作答的長度：{{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "把握程度",
			"pointsEarned": "分數",
			"word": "字",
			"words": "字數",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "你花了 {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) 閱讀並回答這道題目",
			"skill_tooltip": "這道題目所評量的能力領域：{{skill}}",
			"answered_correct_tooltip": "你送出的答案正確",
			"answered_incorrect_tooltip": "你送出的答案錯誤",
			"skipped_tooltip": "你沒有為這道題目送出答案",
			"words_tooltip": "你書面作答的字數：{{count}}",
			"word_tooltip": "你書面作答的字數：{{count}}",
			"confidence_tooltip": "你送出答案時的把握程度",
			"points_earned_tooltip_one": "這道題目滿分 {{maximumScore}} 分，你獲得 {{points}} 分",
			"points_earned_tooltip_other": "這道題目滿分 {{maximumScore}} 分，你獲得 {{points}} 分",
			"challengers_tooltip": "在你之前作答過這道題目的學習者人數：{{count}}",
			"learning_mode_points_tooltip": "這次作答獲得的分數：+{{xp}} XP",
			"pts_earned_tooltip": "這次作答獲得的分數：{{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "展開明細"
		},
		"explanation": {
			"title": "解析",
			"feedback": "回饋",
			"skippedFeedbackNotice": "你略過了這道題目，因此沒有產生個人化回饋。"
		},
		"followUps": "延伸提問",
		"suggestCorrection": "建議修正",
		"answer": {
			"correct": "正確",
			"incorrect": "錯誤",
			"skipped": "已略過"
		},
		"confidence": {
			"high": "高",
			"medium": "中",
			"low": "低"
		},
		"endDialog": {
			"title": "要提前結束練習嗎？",
			"confirmEndDiagnostic": "確定要結束這次練習嗎？所有進度都會遺失，你必須從頭開始。",
			"confirmEnd": "你還有 {{num}} {{itemLabel}}尚未完成。你可以現在結束，或繼續作答完成它們。",
			"confirmEndNoAnswer": "你還沒有回答任何題目，確定要現在結束嗎？",
			"confirmEndNoAnswerPositive": "繼續作答",
			"confirmEndNoAnswerNegative": "立即結束"
		},
		"permissionDialog": {
			"title": "需要麥克風權限",
			"descriptionWeb": "口說練習需要使用你的麥克風。你的瀏覽器封鎖了本網站的存取權限，請點選網址列旁的權限圖示，允許使用麥克風後再試一次。",
			"descriptionMobile": "口說練習需要使用你的麥克風。請在裝置設定中允許存取麥克風以繼續。",
			"promptDescriptionWeb": "口說練習需要使用你的麥克風。請要求權限，並在瀏覽器詢問時選擇「允許」。",
			"blockedDescriptionWeb": "本網站的麥克風存取權限已被封鎖。請點選網址列旁的圖示，允許使用麥克風後再次要求權限。",
			"ok": "確定",
			"cancel": "取消",
			"openSettings": "開啟設定",
			"requestPermission": "要求權限",
			"dismissAndExit": "關閉並離開",
			"learnMore": "了解更多"
		},
		"audioPlaybackTestDialog": {
			"title": "測試音訊播放",
			"description": "{{appName}} 應用程式包含多項音訊播放功能，例如題幹素材、測驗題目與文字轉語音。為確保最佳體驗，請在下方測試你的音訊。確認正常運作後即可繼續。",
			"troubleshooting": {
				"title": "音訊問題排解",
				"volumeTitle": "檢查裝置音量",
				"volumeDescriptionWeb": "使用鍵盤控制鍵，或選單列／工作列中的系統音量設定來調整音量",
				"volumeDescriptionMobile": "使用裝置的音量按鍵，或在系統設定中調整",
				"outputTitle": "確認音訊輸出裝置",
				"outputDescription": "如果使用耳機，請確認耳機已正確連接並設為目前的輸出裝置",
				"browserTitle": "檢查瀏覽器分頁音訊",
				"browserDescription": "查看分頁標題旁是否有靜音喇叭圖示，若有請取消靜音。"
			},
			"skipCheck": "下次略過此項檢查",
			"workingButton": "確認音訊正常",
			"textToHear": "你應該會聽到：{{text}}"
		},
		"overall": "整體",
		"subskills": {
			"content": {
				"title": "內容"
			},
			"languageUse": {
				"title": "語言運用"
			},
			"organizationAndDevelopment": {
				"title": "組織與鋪陳"
			},
			"topicDevelopment": {
				"title": "主題發展"
			},
			"delivery": {
				"title": "表達方式"
			}
		},
		"finalizing": {
			"title": "正在整理你的結果",
			"gradingProgress": "正在評分作答內容..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "口說任務，學習者須盡可能準確地複述聽到的句子。",
			"Read Aloud": "口說題，學習者須朗讀一段文字以接受評量。",
			"Describe Image": "口說任務，學習者須詳細描述一幅圖像。",
			"Write Essay": "寫作任務，須就指定題目撰寫一篇結構完整的作文。",
			"Retell Lecture": "口說任務，學習者須總結所聽到的講座或演講內容。",
			"Summarize Group Discussion": "聽力任務，學習者須總結多位說話者參與的討論。",
			"Answer Short Question": "簡短口說任務，學習者須簡潔回答一個簡短問題。",
			"Respond to a Situation": "口說任務，學習者須對所描述的情境做出恰當回應。",
			"Summarize Written Text": "閱讀任務，學習者須用自己的話總結一段文字。",
			"Reorder Paragraph": "閱讀任務，學習者須將打亂的段落排成正確順序。",
			"Fill in the Blanks (Dropdown)": "閱讀任務，學習者須從下拉選項中選擇答案填入每個空格。",
			"Fill in the Blanks (Type In)": "聽力任務，學習者須輸入缺少的單字或短語。",
			"Fill in the Blanks (Drag and Drop)": "閱讀任務，學習者須將選項拖曳到空格中填入缺少的單字。",
			"Multiple Choice, Single Answer": "單選題，學習者須選擇一個正確答案。",
			"Multiple Choice, Single Answer (Reading)": "閱讀單選題，學習者須選擇一個正確答案。",
			"Multiple Choice, Single Answer (Listening)": "聽力單選題，學習者須選擇一個正確答案。",
			"Multiple Choice, Multiple Answers": "多選題，學習者可選擇多個正確答案。",
			"Multiple Choice, Multiple Answers (Reading)": "閱讀多選題，學習者可選擇多個正確答案。",
			"Multiple Choice, Multiple Answers (Listening)": "聽力多選題，學習者可選擇多個正確答案。",
			"Summarize Spoken Text": "聽力任務，學習者須寫出所聽內容的摘要。",
			"Highlight Correct Summary": "聽力任務，學習者須標示與音訊內容最相符的摘要。",
			"Select Missing Word": "聽力填空任務，學習者須選出缺少的單字。",
			"Highlight Incorrect Words": "聽力任務，學習者須標示逐字稿中與音訊不符的單字。",
			"Write from Dictation": "聽力任務，學習者須聽寫聽到的句子。"
		}
	},
	"report": {
		"readFullInsights": "查看完整洞察",
		"productName": "{{examName}} {{type}}",
		"startedAt": "開始於 {{time}}",
		"itemTypesTitle": "題目類型分析",
		"itemTypesFilterAll": "全部",
		"questionTypeCardTitle": "{{skill}}題目類型分析",
		"questionTypeCardSubtitle_one": "根據本次練習中的 {{count}} 種{{skill}}題目類型",
		"questionTypeCardSubtitle_other": "根據本次練習中的 {{count}} 種{{skill}}題目類型",
		"questionTypeCardAltSubtitle_one": "根據本次練習中的 {{count}} 種題目類型",
		"questionTypeCardAltSubtitle_other": "根據本次練習中的 {{count}} 種題目類型",
		"questionTypeRowSubtitle_zero": "未作答任何題目",
		"questionTypeRowSubtitle_one": "已作答 {{count}} 題",
		"questionTypeRowSubtitle_other": "已作答 {{count}} 題",
		"itemTypeDetail": {
			"review_one": "檢閱題目",
			"review_other": "檢閱題目",
			"stats": {
				"answered_one": "已作答題目",
				"answered_other": "已作答題目",
				"avgTime": "每題平均時間"
			}
		},
		"reviewAnswersDialog": {
			"title": "檢閱答案",
			"sections": {
				"skills": "能力項目",
				"questionTypes": "題型",
				"proficiency": "程度",
				"performance": "表現"
			},
			"summaryNone": "請選擇有題目的篩選條件以繼續。",
			"summaryAll_one": "檢閱全部 {{count}} 個答案。",
			"summaryAll_other": "檢閱全部 {{count}} 個答案。",
			"summaryFiltered_one": "檢閱符合 {{filters}} 的 {{count}} 個答案。",
			"summaryFiltered_other": "檢閱符合 {{filters}} 的 {{count}} 個答案。",
			"reviewAnswers_one": "檢閱 {{count}} 個答案",
			"reviewAnswers_other": "檢閱 {{count}} 個答案",
			"more": "另外 {{count}} 個"
		},
		"itemDetail": {
			"title": "檢閱我的答案",
			"filterAll": "全部",
			"filterCorrect": "正確",
			"filterIncorrect": "錯誤",
			"filterMarked": "已標記",
			"emptyTitle": "沒有符合的題目",
			"emptyDescription": "你這次練習的題目都不符合所選的篩選條件（{{filter}}）。請調整或清除篩選條件以查看更多結果。",
			"emptyCta": "清除篩選條件"
		},
		"answerCardTitle": "已作答題目",
		"answerCardSubtitle_one": "看看你在所有題目上的表現",
		"answerCardSubtitle_other": "看看你在全部 {{count}} 道題目上的表現",
		"skillsBreakdown": {
			"title": "能力分析",
			"subtitle_one": "根據 {{count}} 道題目",
			"subtitle_other": "根據 {{count}} 道題目"
		},
		"studyPack": "學習包",
		"practiceTestCompleted": "模擬測驗已完成",
		"studySessionCompleted": "學習練習已完成",
		"diagnosticSessionCompleted": "診斷測驗已完成",
		"timeElapsed": "經過時間",
		"stats": {
			"answered": "已作答",
			"time elapsed": "經過時間",
			"avg speed": "平均速度",
			"hints used": "已使用提示"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "表現出色，請繼續朝卓越邁進！",
				"highIntermediate": "你做得很好，繼續磨練你的強項！",
				"lowIntermediate": "你正穩定進步中，繼續保持！",
				"basic": "繼續努力，提升你的能力！"
			},
			"infoText": "你完成了 **{{numActivities}} {{activityLabel}}**，用來練習你的{{skillsText}}{{skills}}。{{skillDetails}}。整體而言，你獲得 **{{numTotalPoints}} 分中的 {{numPointsEarned}} 分**，顯示你在{{thisText}}{{skills}}上具備 **{{compositeLevel}}程度**。{{compositeFeedback}}",
			"infoText.singleSkill": "你完成了 **{{itemCount}} {{itemLabel}}**，著重於你的 **{{skill_1}}** 能力。你獲得 **{{skill_1_total}} 分中的 {{skill_1_score}} 分**，顯示你具備 **{{proficiency}}** 程度。{{compositeFeedback}}",
			"infoText.multiSkill": "你完成了 **{{itemCount}} {{itemLabel}}**，練習了你的 **{{skills_text}}** 能力。{{skill_details}} 整體而言，你獲得 **{{overall_total}} 分中的 {{overall_score}} 分**，顯示你在這些能力上具備 **{{overall_proficiency}}** 程度。{{compositeFeedback}}",
			"skillDetails": "在 **{{skill}}** 方面，你獲得 **{{total}} 分中的 {{score}} 分**，顯示你具備 **{{proficiency}}** 程度。"
		},
		"actions": {
			"goToHome": "前往首頁",
			"studyMore": "繼續學習",
			"studyFree": "免費學習{{tagTypes}}",
			"reviewAnswers": "檢閱答案"
		},
		"nextAction": {
			"title": "推薦：{{focus}}練習",
			"dialog": {
				"title": "推薦的學習練習",
				"subtitle": "著重加強你的落差領域"
			},
			"fallback": {
				"title": "繼續練習",
				"description": "針對你接下來想加強的部分安排一次學習練習。"
			}
		},
		"premium": {
			"upgradeCta": "升級進階版"
		},
		"disclaimer": {
			"title": "免責聲明",
			"summativeBody": "模擬測驗分數僅供參考，不保證在正式 {{examName}} 測驗中會獲得相同結果。"
		},
		"performance": {
			"title": "表現",
			"subtitle": "根據 {{count}} 道題目",
			"correct": "正確",
			"correctItems": "{{count}} 題",
			"incorrect": "錯誤",
			"incorrectItems": "{{count}} 題"
		},
		"mastery": {
			"performanceTitle": "表現",
			"sessionMasteryTitle": "預估程度",
			"subtitle_assessment": "根據本次評量的全部 {{count}} {{item}}",
			"subtitle_session": "根據本次練習的全部 {{count}} {{item}}"
		},
		"sessionAnalysis": {
			"title": "練習分析",
			"subtitle": "個人化分析與建議",
			"viewFullAnalysis": "查看分析",
			"feedbackDialog": {
				"body": "我們幾乎每天都在更新，也持續努力改進。願意留下你的意見嗎？",
				"placeholder": "請在此輸入你的意見",
				"cta": "送出意見",
				"successMessage": "意見已送出，謝謝你！",
				"feedbackLimitError": "意見內容至少需要 10 個字"
			},
			"menuActions": {
				"copy": "複製",
				"altCopy": "複製摘要文字",
				"altPositiveFeedback": "這很有幫助",
				"positiveFeedback": "回應很好",
				"negativeFeedback": "回應不佳",
				"reportIssue": "回報",
				"altReportIssue": "回報這則回應",
				"emailSummary": "以電子郵件寄送摘要文字",
				"emailAlreadySent": "已寄出電子郵件",
				"copiedAnalysis": "已將分析複製到剪貼簿",
				"emailSent": "已將電子郵件寄至 {{email}}。如果沒有收到，請檢查垃圾郵件、廣告郵件與最近刪除的資料夾",
				"emailFailed": "無法將電子郵件寄至 {{email}}",
				"emailInstructionMessage": "如果沒有收到電子郵件，請檢查垃圾郵件、廣告郵件與最近刪除的資料夾，或聯絡你的 IT 管理員"
			}
		}
	},
	"feedback": {
		"successMessage": "意見已送出，謝謝你！"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "你喜歡哪些地方？有哪些可以改進？我們每天都在改善這個平台，團隊也會閱讀每一則意見。謝謝你！",
			"title": "分享你的意見",
			"body": "你喜歡哪些地方？有哪些可以改進？我們每天都在改善這個平台，團隊也會閱讀每一則意見。**謝謝你！**",
			"positiveBody": "很高興這對你有幫助！請告訴我們**你喜歡的地方。**",
			"negativeBody": "請幫助我們了解問題所在，讓我們能**改善回應品質。**",
			"placeholder": "請輸入意見",
			"cta": "送出意見"
		},
		"report": {
			"title": "送出回報",
			"body": "請幫助我們了解這則回應有什麼問題",
			"cta": "送出回報"
		},
		"suggestCorrection": {
			"title": "建議修正",
			"body": "**回報任何錯誤**，協助我們提升這項內容的正確性。",
			"cta": "送出"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "不正確",
					"description": "回應內容包含錯誤資訊"
				},
				"notHelpful": {
					"title": "沒有幫助",
					"description": "回應沒有解答我的問題"
				},
				"incomplete": {
					"title": "不完整",
					"description": "回應缺少重要細節"
				},
				"hardToUnderstand": {
					"title": "難以理解",
					"description": "回應令人困惑或不夠清楚"
				},
				"other": {
					"title": "其他",
					"description": "其他原因"
				}
			},
			"report": {
				"misinformation": {
					"title": "不實資訊",
					"description": "回應包含不實或誤導性的資訊"
				},
				"harmfulContent": {
					"title": "有害或冒犯性內容",
					"description": "仇恨言論、騷擾或不當用語"
				},
				"violatesPolicies": {
					"title": "違反政策",
					"description": "垃圾訊息、自我推銷或非法內容"
				},
				"other": {
					"title": "其他",
					"description": "請用你自己的話說明問題所在"
				}
			}
		},
		"faqs": {
			"title": "常見問題",
			"body": "以下是關於這個應用程式最常見的一些問題。如果你還有其他疑問，歡迎來信 support@memorang.ai"
		},
		"delete": {
			"title": "刪除帳號",
			"body": "很遺憾看到你離開，祝你在學業與職涯的路上一切順利！",
			"options": "價格太高|我已經考完試了|不喜歡內容|缺少需要的功能|其他",
			"confirmdelete": {
				"title": "確認刪除帳號",
				"cta": "刪除",
				"errorMessage": "很抱歉，這個電子郵件與本帳號不符，請再試一次",
				"successMessage": "帳號已成功刪除！",
				"validEmail": "請輸入有效的電子郵件地址"
			}
		}
	},
	"recorder": {
		"tapToRecord": "點選以錄下你的回答",
		"responseAudioUnavailable": "無法播放你的回答錄音",
		"recording": "錄音中",
		"recordingCompleted": "錄音完成",
		"getReady": "請準備",
		"timeIsUp": "時間到，你的回答並未錄下。",
		"alert": {
			"title": "已達最長錄音時間",
			"body": "錄音已停止，因為已達到 {{maxDuration}} 秒的最長錄音時間。"
		},
		"uiElementPressed": "錄音已停止 — 錄音進行期間開啟了題幹素材。"
	},
	"writing": {
		"placeholder": "請在此撰寫你的回答...",
		"wordCount": "{{count}} {{word}}",
		"title": "你的回答",
		"submit": "送出",
		"helper": {
			"range": "請撰寫 {{min}}–{{max}} 個字以送出你的回答",
			"min": "請至少撰寫 {{min}} 個字以送出你的回答",
			"max": "請將回答縮短至 {{max}} 個字以內"
		}
	},
	"navbar": {
		"home": "首頁",
		"progress": "學習進度",
		"insights": "洞察",
		"leaderboard": "排行榜",
		"store": "商店",
		"more": "更多",
		"redeem": "兌換",
		"study-pack": "學習包",
		"podcasts": "Podcast",
		"modules": "模組",
		"account": "帳號設定",
		"accountTab": "帳號",
		"privacy": "隱私權",
		"terms": "條款",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "代碼輸入正確但問題仍未解決？**聯絡支援團隊**，並記得附上你的存取代碼與購買詳情",
		"olxDialog": {
			"unlockedTitle": "存取權限已解鎖",
			"expiredTitle": "存取權限已過期",
			"testInfo": "**考試：** {{examName}} | **測驗：** {{bundleName}}",
			"upcomingBody_one": "你對 OLX 測驗的存取權限已解鎖！\n\n你可以在 **{{count}} 天**後開始測驗。請稍後回到練習測驗分頁以開始測驗。",
			"upcomingBody_other": "你對 OLX 測驗的存取權限已解鎖！\n\n你可以在 **{{count}} 天**後開始測驗。請稍後回到練習測驗分頁以開始測驗。",
			"activeBody": "你對 OLX 測驗的存取權限現已生效！\n\n你可以在 **{{date}}** 之前隨時開始測驗。\n\n你想現在開始測驗，還是稍後再開始？",
			"expiredBody": "你對 OLX 測驗的存取權限已於 **{{date}}** 過期。\n\n如需進一步協助，請聯絡你的教授或學校管理員。",
			"startNowCta": "立即開始",
			"startLaterCta": "稍後開始"
		},
		"unexpectedError": "發生了意外錯誤。"
	},
	"redeemCode": {
		"titleRedeem": "兌換使用權",
		"titleGranted": "已開通使用權",
		"formTitle": "請輸入你的存取碼",
		"accessCodeHint": "如果你有存取碼，請連同破折號一起輸入於此。",
		"submit": "兌換",
		"access": "由此進入",
		"helpFindCode": "需要協助尋找你的代碼嗎？",
		"troubleRedeeming": "兌換時遇到問題嗎？問問小幫手！",
		"skipStep": "略過此步驟"
	},
	"autoRedeem": {
		"redeem": "兌換",
		"redeeming": "兌換中...",
		"continue": "繼續",
		"unredeemedPrompt_one": "與電子郵件 **{{email}}** 相關聯的**{{count}} 項產品**尚未兌換，要將它加入你的帳號嗎？",
		"unredeemedPrompt_other": "與電子郵件 **{{email}}** 相關聯的**{{count}} 項產品**尚未兌換，要將它們加入你的帳號嗎？",
		"successMessage_one": "恭喜！下方的**產品**已在你的帳號中解鎖。按下繼續後，應用程式的內容將切換為以下考試：**{{examName}}**。若你想準備其他考試或購買其他產品，隨時可在帳號設定中變更。",
		"successMessage_other": "恭喜！下方的**{{count}} 項產品**已在你的帳號中解鎖。按下繼續後，應用程式的內容將切換為以下考試：**{{examName}}**。若你想準備其他考試或購買其他產品，隨時可在帳號設定中變更。"
	},
	"olxEligibility": {
		"goToPracticeTests": "前往模擬測驗"
	},
	"moreChallenges": {
		"challenges": "挑戰",
		"challengesCount": "{{value}} 項挑戰"
	},
	"tts": {
		"tooltip": "聆聽"
	},
	"commandBar": {
		"placeholder": "搜尋...",
		"input": {
			"placeholder": "輸入指令或搜尋"
		},
		"sections": {
			"quickActions": "快速操作"
		},
		"actions": {
			"changeExam": "變更考試",
			"switchToDarkMode": "切換為深色模式",
			"switchToLightMode": "切換為淺色模式",
			"setExamDate": "設定考試日期"
		}
	},
	"filterView": {
		"placeholder": "搜尋考試..."
	},
	"transcript": {
		"show": "顯示逐字稿",
		"hide": "隱藏逐字稿"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "應用程式標誌",
			"testNameLabel": "測驗名稱",
			"sectionLabel": "測驗區塊",
			"back": "返回",
			"pause": "暫停",
			"menuLabel": "更多選項"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "測驗進度",
			"of": "／",
			"pauseSession": "暫停測驗",
			"timerTooltip": {
				"item": "本題剩餘時間",
				"section": "本區塊剩餘時間",
				"test": "本次測驗剩餘時間"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "下一題"
		},
		"progressBar": {
			"timeLeftLabel": "本題剩餘時間",
			"timeLeftForUnit": "本單元剩餘時間",
			"questionOf": "第 {{current}} 題，共 {{total}} 題",
			"questionProgress": "<b>{{current}}</b>／{{total}}",
			"timesUp": "時間到",
			"statusTooltips": {
				"answered": "已作答",
				"inProgress": "進行中",
				"skipped": "已略過",
				"notSeen": "尚未檢視"
			}
		},
		"timeRemainingDialog": {
			"title": "你還有時間",
			"body": "本單元還有剩餘時間，你想在送出前先檢閱答案嗎？",
			"reviewCta": "檢閱我的答案"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "原文",
				"answerTitle": "你的答案",
				"remainingBadge": "剩餘 {{count}} 段",
				"placedBadge": "已放置 {{count}} 段",
				"pointsBadge": "{{earned}}/{{max}} 分",
				"emptyHint": "請從左側面板將段落拖曳到這裡"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "客服資訊",
			"emailLabel": "電子郵件",
			"subjectLabel": "主旨",
			"messageBodyLabel": "訊息內容",
			"appDetailsLabel": "應用程式資訊",
			"appNameLabel": "名稱",
			"versionLabel": "版本",
			"platformLabel": "平台"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} 支援助理",
			"fallbackTitle": "聊天",
			"betaWarning": "此 AI 助理處於**測試版**——回覆偶爾可能不準確或不完整。",
			"greeting": "你好 👋 在取得產品存取權限時遇到問題了嗎？我來幫你！首先，我們先釐清問題所在。以下哪一項最符合你的情況？\n\n1. 我有存取代碼，但似乎無法使用。\n2. 我已購買，但找不到我的存取代碼。\n3. 我應該已透過學校取得存取權限，但找不到我的存取代碼。\n4. 我之前擁有某產品的存取權限，但目前無法存取。\n\n請輸入對應你問題的數字。",
			"input": {
				"label": "輸入訊息...",
				"sendLabel": "傳送"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 兌換成功",
			"previouslyRedeemedTitle": "🚀 先前已兌換",
			"subtitle": "在此存取你的內容",
			"expires": "到期日：{{date}}",
			"openCta": "開啟"
		},
		"purchases": {
			"title": "🎉 已找到存取代碼",
			"subtitle": "兌換以存取你的內容",
			"accessCodesLabel_one": "存取代碼",
			"accessCodesLabel_other": "存取代碼",
			"moreCodes_one": "（+ 還有 {{count}} 個）",
			"moreCodes_other": "（+ 還有 {{count}} 個）",
			"featuresLabel": "功能",
			"redeemCta": "兌換"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "有新版本可用，請點選重新整理以更新。",
			"refreshCta": "重新整理",
			"refreshA11yLabel": "重新整理以更新應用程式",
			"dismissTooltip": "關閉",
			"dismissA11yLabel": "關閉更新通知"
		}
	},
	"cme": {
		"type": "CME 類型",
		"chooseExportMethod": "選擇匯出方法",
		"selectDateRange": "選擇日期範圍",
		"from": "從",
		"to": "至",
		"sendPdfTo": "將 PDF 傳送至 {{email}}",
		"downloadCertificate": "將憑證下載為 PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "已獲得的 CME 學分",
		"confirmYourName": "確認您的姓名",
		"certificateNameNotice": "此姓名將被列印在您的 CME 憑證上。",
		"firstName": "名字",
		"lastName": "姓氏",
		"firstNamePlaceholder": "請輸入您的名字",
		"lastNamePlaceholder": "請輸入您的姓氏",
		"confirm": "確認",
		"creditsEarnedTitle": "已獲得的 CME",
		"creditRatioCaption": "12 項挑戰 = 1 個 CME 學分",
		"earned": "已獲得",
		"available": "可用",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "匯出 CME 憑證",
		"exportDisabledCaption": "您需要至少獲得 1 個 CME 學分才能匯出您的憑證",
		"viewDisclaimer": "檢視 CME 免責聲明"
	}
}
